import { html } from "lit";
var icon_google_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M9.016 10.709c.239.186.58.156.783-.07a8.052 8.052 0 0111.87-.149.575.575 0 00.817 0l3.358-3.151a.575.575 0 000-.817 13.803 13.803 0 00-20.508.46.575.575 0 00.115.851l3.565 2.876zm-.989 8.501a.575.575 0 00.161-.61 7.925 7.925 0 010-5.13.575.575 0 00-.184-.633L4.243 9.835a.575.575 0 00-.874.195 13.722 13.722 0 00.172 12.25.575.575 0 00.897.161l3.59-3.232zm21.579-4.935a.575.575 0 00-.575-.575H17.528a.575.575 0 00-.575.575v4.6c0 .318.258.576.575.576h5.567a7.81 7.81 0 01-1.311 1.92.575.575 0 000 .771l3.071 3.451a.575.575 0 00.84 0 13.803 13.803 0 003.91-8.903v-2.415zm-9.754 9.155a.575.575 0 00-.667-.138 7.971 7.971 0 01-9.317-1.874.575.575 0 00-.806 0L5.612 24.5a.575.575 0 000 .817 13.803 13.803 0 0017.253 2.588.575.575 0 00.138-.874l-3.151-3.6z" />
  </svg>
`;
export {
  icon_google_default as default
};
//# sourceMappingURL=icon-google.js.map
